import { render, staticRenderFns } from "./TheConfirmationModal.vue?vue&type=template&id=00065123"
import script from "./TheConfirmationModal.vue?vue&type=script&lang=js"
export * from "./TheConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports